import { fetchBasket } from '@/shared/basketStore.js';
import BasketPanel from '@/components/BasketPanel.vue';

// What redemption does once a voucher resolves - the half of the journey that is not about
// identifying the code.
//
// Shared, because there are two ways into it: the header's Redeem bar, and the Redeem button
// on a balance result. Both post the same code to the same endpoint and must finish the same
// way, so having this in one place is what stops them diverging - a customer who checked a
// balance first should not end up somewhere different from one who did not.
//
// Pass it as `onOutcome` to createVoucherFlow(). Returns true for the outcomes it owns and
// false for everything else, which then falls through to the flow's shared defaults.

/**
 * @param {object} data - the endpoint's JSON.
 * @param {{state: object, show: function, end: function}} helpers - from the calling flow.
 */
export function redeemOutcome(data, { state, show, end }) {
    switch (data.outcome) {
        case 'validated':
        case 'already_in_basket':
            // The voucher is on the basket either way; `next` says where the customer goes.
            // 'basket' means it already covers something they had chosen, so hand straight
            // over to the basket panel - the same move CalendarBookingPanel makes after an
            // add. Its contents are refetched first: the voucher has just changed what the
            // basket costs, and the panel renders whatever the store last saw.
            if (data.next === 'basket') {
                fetchBasket();
                show(BasketPanel, {}, 'Your Basket');

                return true;
            }

            // Otherwise it covers nothing chosen yet, so they pick on the entitled-product
            // page. A full navigation, not a panel: it is a grid of products, and leaving
            // the journey open behind it would give them a panel to come back to that no
            // longer describes where they are. Closing first means the panel goes now rather
            // than flashing away when the new page paints.
            end();
            window.location.assign(data.url);

            return true;

        case 'expired':
            // Names the expiry date, so it is worth showing rather than paraphrasing.
            state.error = data.message;

            return true;

        case 'max_vouchers':
            state.error = 'You already have the maximum number of vouchers on this order. '
                + 'To use more, please contact us.';

            return true;
    }

    return false;
}
